import { Component, OnInit } from '@angular/core';

import { ContainerViewModel } from '../../types/control.types';
import { ControlTypeName } from '../../types/control-type-name';
import { AbstractControlContainerComponent } from '../abstract-control-container/abstract-control-container.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: '[dy-container]',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.css']
})
export class ContainerComponent extends AbstractControlContainerComponent<ContainerViewModel> implements OnInit {
  type: string = ControlTypeName.container;
  isDesign: boolean = false;
  model: ContainerViewModel;

  constructor() {
    super();
  }

  ngOnInit() {}
}
